import React from 'react'

export class ProjectWorkspace extends React.Component {
  render() {
    return (
      <h1>Project page</h1>
    )
  }
}